var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ActivityAuditClient, ActivityAuditFilterOptionsModel, GetActivityAuditCSVReportQuery, GetActivityAuditFilterOptionsQuery, GetActivityAuditPaginatedQuery, PaginatedEnumerableOfActivityAuditModel, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { DateHelper } from "@/app/utils/date-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import { Component, Vue, Watch } from "vue-facing-decorator";
import moment from "moment";
const activityAuditClient = new ActivityAuditClient(window.apiUrl);
let AuditLogVue = class AuditLogVue extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.working = false;
        this.searchAttempted = false;
        this.exporting = false;
        this.sorter = new Sorter(new SortDescription({
            fieldName: "WhenCreated",
            direction: SortDirection.Descending
        }));
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig();
        this.dateFilterOptions = ["1 Day", "3 Days", "5 Days", "Week", "Month", "..."];
        this.dateFilterOption = "";
        this.startTime = null;
        this.endTime = null;
        this.data = new PaginatedEnumerableOfActivityAuditModel();
        this.filterOptions = new ActivityAuditFilterOptionsModel();
        this.query = new GetActivityAuditPaginatedQuery({
            page: 1,
            pageSize: 100,
            keywords: null,
            sort: this.sorter.currentSort
        });
        // Only one entry is expanded at a time. Detail rows are fetched on demand rather than with the
        // list, which is what keeps a page of a hundred entries to a single query.
        this.expandedId = null;
        this.expandedDetails = [];
        this.loadingDetailsFor = null;
    }
    get noData() {
        var _a, _b;
        return this.searchAttempted && !this.loading && ((_b = (_a = this.data.records) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) === 0;
    }
    get showDatePickers() {
        return this.dateFilterOption === "...";
    }
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            this.resetDateFilterOption();
            yield this.loadFilterOptions();
            yield this.search();
        });
    }
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        this.search();
    }
    onPageChanged() {
        this.search();
    }
    loadFilterOptions() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.filterOptions = yield activityAuditClient.filterOptions(new GetActivityAuditFilterOptionsQuery({ daysToConsider: 90 }));
            }
            catch (_a) {
                // A filter bar that failed to populate should not stop the log itself being readable.
                this.filterOptions = new ActivityAuditFilterOptionsModel();
            }
        });
    }
    search() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.working)
                return;
            const startDate = this.startTime ? DateHelper.convertToDate(this.startTime) : null;
            let endDate = this.endTime ? DateHelper.convertToDate(this.endTime) : null;
            if (endDate != null)
                endDate = DateHelper.getEndOfDay(endDate);
            if (!DateHelper.validateDateRange(startDate, endDate)) {
                Notifier.onWarning("Please enter valid dates. The start date must be before the end date.");
                return;
            }
            this.working = true;
            this.loading = true;
            this.collapseDetails();
            const query = this.query;
            query.startTime = startDate;
            query.endTime = endDate;
            try {
                const response = yield activityAuditClient.search(this.query);
                if (response) {
                    this.data = response;
                    this.query.page = this.data.displayedPage;
                    this.query.pageSize = this.data.pageSize;
                }
            }
            catch (error) {
                Notifier.onError("The Audit Log could not be loaded.");
            }
            finally {
                this.searchAttempted = true;
                this.loading = false;
                this.working = false;
            }
        });
    }
    /// Exports what is currently on screen. The server re-applies the same scope and filters, so
    /// the file is the rows the user is looking at - the query sent here is a request, not a
    /// grant.
    exportCsv() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (this.exporting)
                return;
            this.exporting = true;
            try {
                const response = yield activityAuditClient.exportCsv(new GetActivityAuditCSVReportQuery({
                    query: this.query,
                    timezoneOffset: DateHelper.getTimezoneOffset()
                }));
                DownloadUtil.handleFileDownload(response);
            }
            catch (error) {
                // The server refuses an export that is too large and says how to narrow it. Showing
                // that message is far more useful than a generic failure.
                Notifier.onError((_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : "The Audit Log could not be exported.");
            }
            finally {
                this.exporting = false;
            }
        });
    }
    isExpanded(item) {
        return this.expandedId === item.activityAuditId;
    }
    toggleDetails(item) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (this.isExpanded(item)) {
                this.collapseDetails();
                return;
            }
            // Always fetch, never trust the count to decide. The count is a hint for the chevron; if
            // it is ever wrong, skipping the fetch turns every row into "no changes were recorded",
            // which is exactly how this looked before.
            this.expandedId = item.activityAuditId;
            this.expandedDetails = [];
            this.loadingDetailsFor = item.activityAuditId;
            try {
                // whenCreated is passed so PostgreSQL can prune to the one partition the entry lives in
                // rather than searching every one of them.
                const entry = yield activityAuditClient.get(item.activityAuditId, item.whenCreated);
                this.expandedDetails = (_a = entry === null || entry === void 0 ? void 0 : entry.details) !== null && _a !== void 0 ? _a : [];
            }
            catch (_b) {
                Notifier.onError("The changes for this entry could not be loaded.");
                this.collapseDetails();
            }
            finally {
                this.loadingDetailsFor = null;
            }
        });
    }
    collapseDetails() {
        this.expandedId = null;
        this.expandedDetails = [];
        this.loadingDetailsFor = null;
    }
    setDateFilterOption(option) {
        this.dateFilterOption = option;
        if (option === "...")
            return;
        const now = moment();
        switch (option) {
            case "1 Day":
                this.startTime = now.clone().subtract(1, "days").format("YYYY-MM-DD");
                break;
            case "3 Days":
                this.startTime = now.clone().subtract(3, "days").format("YYYY-MM-DD");
                break;
            case "5 Days":
                this.startTime = now.clone().subtract(5, "days").format("YYYY-MM-DD");
                break;
            case "Week":
                this.startTime = now.clone().subtract(7, "days").format("YYYY-MM-DD");
                break;
            case "Month":
                this.startTime = now.clone().subtract(1, "months").format("YYYY-MM-DD");
                break;
        }
        this.endTime = null;
        this.query.page = 1;
        this.search();
    }
    resetDateFilterOption() {
        this.dateFilterOption = "Week";
        this.startTime = moment().subtract(7, "days").format("YYYY-MM-DD");
        this.endTime = null;
    }
    /// Rendered in the viewer's own time zone, with the UTC value on hover - an audit trail is
    /// read by people in different places, and "3pm" is ambiguous without it.
    formatTimeString(value) {
        return value ? moment(value).format("DD/MM/YYYY HH:mm:ss") : "";
    }
    formatUtc(value) {
        return value ? `${moment.utc(value).format("DD/MM/YYYY HH:mm:ss")} UTC` : "";
    }
};
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuditLogVue.prototype, "onSortChanged", null);
__decorate([
    Watch("query.page"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuditLogVue.prototype, "onPageChanged", null);
AuditLogVue = __decorate([
    Component({
        name: "AuditLogVue"
    })
], AuditLogVue);
export default AuditLogVue;
